import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { DroppableDirective } from '@modules/directives/droppable.directive';

@Component({
  standalone:true,
  selector: 'app-drag-drop-overlays',
  templateUrl: './drag-drop-overlays.component.html',
  styleUrls: ['./drag-drop-overlays.component.scss'],
  imports:[CommonModule,DroppableDirective]
})
export class DragDropOverlaysComponent implements OnInit {
  universalService:any;
  totalFilesList:any;
  firstFileName:any;
  folderService:any;
  listService:any;
  ppfToken:any='';

  constructor(private globalService:GlobalService) { 
    this.setEnvObjects(this.globalService);
  }

  ngOnInit(): void {
  
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.folderService = globalService.getFolderServiceRef();
    this.listService = globalService.getListServiceRef();
  }

  async getPPFToken(){
    await this.listService.getPPFToken();
    this.ppfToken = encodeURIComponent(this.universalService.header_X_PPF_TOKEN)
  }

}
